import { updateRangesRelativeValues, mapRanges } from 'nmr-processing';
import { initSumOptions } from '../SumManager';
import autoRangesDetection from './autoRangesDetection';
export function detectRanges(spectrum, options) {
    const { molecules, nucleus, ...detectOptions } = options;
    detectOptions.impurities = { solvent: spectrum.info.solvent || '' };
    const ranges = autoRangesDetection(spectrum, detectOptions);
    spectrum.ranges.options = initSumOptions(spectrum.ranges.options, {
        molecules,
        nucleus,
    });
    spectrum.ranges.values = spectrum.ranges.values.concat(mapRanges(ranges, spectrum));
    updateRangesRelativeValues(spectrum);
}
